import React from 'react';
import PropTypes from 'prop-types';

class NotifyOutsideClick extends React.Component {
    constructor(props) {
        super(props);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        let isKendoMenuItem = false;

        if (this.props.ignoreKendoMenus) {
            // SVG elements expose `className` as an `SVGAnimatedString`
            // (no `.includes`), so `className.includes('…')` throws when the
            // click lands on an inline svg (e.g. Kendo v14's clear-X icon).
            // `classList` is uniform across HTML and SVG.
            const cl = event.target.classList;
            isKendoMenuItem = cl && (
                cl.contains('k-menu-link-text') ||
                cl.contains('k-menu-item') ||
                cl.contains('k-menu-link') ||
                event.target.closest('.k-popup') ||
                event.target.closest('.k-menu')
            );
        }

        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !isKendoMenuItem) {
            this.props.action();
        }
    }

    render() {
        return <div ref={this.setWrapperRef}>{this.props.children}</div>;
    }
}

NotifyOutsideClick.propTypes = {
    children: PropTypes.element.isRequired,
    action: PropTypes.func,
    ignoreKendoMenus: PropTypes.bool
};

export default NotifyOutsideClick;